import { createSelector } from 'reselect'

import RootState, { TransportResponseState } from '../types'
import State from './types'
import BaseTransport from '../../transports/common/base-transport'
import UserDetailsTransport from '../../transports/user-details-transport'
import UserDetailsModel from '../../models/user/user-details-model'
import { getModel } from '../../utils/model-utils'

const _getUser = (state: RootState): State => state.user

export const getUserDetailsTransportResponseState = createSelector(
    _getUser,
    (user: State): TransportResponseState<BaseTransport<UserDetailsTransport>> => user.userDetails,
)

const _getUserDetailsTransport = createSelector(
    getUserDetailsTransportResponseState,
    (
        userDetails: TransportResponseState<BaseTransport<UserDetailsTransport>>,
    ): BaseTransport<UserDetailsTransport> | null => userDetails.transport,
)

export const getUserDetailsModel = createSelector(
    _getUserDetailsTransport,
    (transport: BaseTransport<UserDetailsTransport> | null): UserDetailsModel | null =>
        transport?.data ? getModel<UserDetailsTransport, UserDetailsModel>(transport.data, transport.meta) : null,
)

// Selector to get favoriteListings directly from transport data for better reactivity
export const getFavoriteListings = createSelector(
    _getUserDetailsTransport,
    (transport: BaseTransport<UserDetailsTransport> | null): string[] => transport?.data?.favoriteListings || [],
)

// Selector to check if user is logged in (has userDetails)
export const getIsLoggedIn = createSelector(
    _getUserDetailsTransport,
    (transport: BaseTransport<UserDetailsTransport> | null): boolean => !!transport?.data,
)
